import {NgModule} from '@angular/core';
import { IonicModule } from '@ionic/angular';
import {SwiperModule} from 'swiper/angular';
import {SliderComponent} from "../components/slider/slider.component";
import {CommonModule} from "@angular/common";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {HttpClientModule} from "@angular/common/http";
import { NgxSplideModule } from 'ngx-splide';
import { PhoneMaskDirective } from './../directives/phone-mask.directive';
import {entRentStatusPipe} from "../pipes/entRent-status.pipe";
import { entProductStatusPipe } from './../pipes/entProduct-status.pipe';

@NgModule({
  imports: [
  IonicModule,
    SwiperModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    CommonModule,
    NgxSplideModule,
  ],
  exports: [
    IonicModule,
    CommonModule,
    SliderComponent,
    SwiperModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    NgxSplideModule,
    PhoneMaskDirective,
    entRentStatusPipe,
    entProductStatusPipe
  ],
  declarations: [
    SliderComponent,
    PhoneMaskDirective,
    entRentStatusPipe,
    entProductStatusPipe
  ]
})
export class SharedModule {}
